import React from 'react';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { useQuery, useMutation } from '@apollo/react-hooks';
import OverlaySpinner from '../../../platform/shared/OverlaySpinner';
import AdvertiserMainController from './AdvertiserMainController';
import compose from 'lodash/flowRight';
import CURRENT_USER from '../../GraphQl/Queries/CURRENT_USER';
// import ADVERTISERS from "../../GraphQl/Queries/ADVERTISERS";
import ADVERTISER_CONNECTION from '../../GraphQl/Queries/ADVERTISER_CONNECTION';
import CREATE_ADVERTISERS from '../../GraphQl/Mutations/CREATE_ADVERTISERS';
import GET_ADMIN_IDS from '../../GraphQl/Queries/GET_ADMIN_IDS';
import GET_LOCATIONS from '../../GraphQl/Queries/GET_LOCATIONS';
import ATTRIBUTION_AUDIENCES_ORG_CONFIG from '../../GraphQl/Queries/ATTRIBUTION_AUDIENCES_ORG_CONFIG';
import { cloneDeep } from 'lodash';
import moment from 'moment';

const AdvertiserMainLoader = (props) => {
  const { children, currentUser, match, location, history } = props;
  const currentOrgId = currentUser.role.org.id;
  const pageNumber = match.params.pageNumber;
  const { permission } = currentUser;
  const orgLevel = currentUser.role.org.level;

  const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') ? parseInt(params.get('pageSize')) : 10;
  const advertiser = params.get('advertiser');

  if (isNaN(pageNumber) || Number(pageNumber) < 1)
    location.search
      ? history.push(`/advertiser/main/1${location.search}`)
      : history.push('/advertiser/main/1');

  const search = params.get('search');
  const status = params.get('status');
  let where = {
    AND: [
      { status_not: 'DEMO' },
      {
        impressionsTag: {
          id_not: null,
        },
      },
    ],
    OR: [
      {
        sharedOrgs_some: {
          org: {
            id: currentOrgId,
          },
        },
      },
      {
        sharedOrgs_some: {
          org: {
            parentOrg_some: { id: currentOrgId },
          },
        },
      },
    ],
  };
  if (status === 'DEMO') {
    where = {
      AND: [{ status: 'DEMO' }],
    };
  }

  let whereFilter = cloneDeep(where);
  if (search) {
    whereFilter['AND'].push({ name_contains: search });
  }

  if (advertiser) {
    whereFilter['AND'].push({
      impressionsTag: {
        orgs_some: {
          id: advertiser,
        },
      },
    });
  }

  if (status) {
    const currentDate = moment().format();
    const attributionWindow = moment().subtract(30, 'days').format();
    if (status === 'PAUSED') {
      whereFilter['AND'].push({ status });
    } else if (status === 'FINISHED') {
      whereFilter['AND'] = [
        ...whereFilter['AND'],
        { status_not: 'PAUSED' },
        { status_not: 'DEMO' },
        { endDate_lt: attributionWindow },
      ];
    } else if (status === 'ATTRIBUTION') {
      whereFilter['AND'] = [
        { status_not: 'PAUSED' },
        { status_not: 'DEMO' },
        { endDate_gte: attributionWindow },
        { endDate_lte: currentDate },
        ...whereFilter['AND'],
      ];
    } else if (status === 'LIVE') {
      whereFilter['AND'] = [
        { status_not: 'PAUSED' },
        { status_not: 'DEMO' },
        { endDate_gt: currentDate },
        ...whereFilter['AND'],
      ];
    }
  }
  // Advertiser Table Data
  const { data, loading, refetch } = useQuery(ADVERTISER_CONNECTION, {
    variables: {
      where: whereFilter,
      orderBy: 'name_ASC',
    },
    fetchPolicy: 'no-cache',
  });

  // fetch admin ids
  const { data: adminIds, loading: adminLoading } = useQuery(GET_ADMIN_IDS);

  // Query for locations for funnel creation
  const { loading: loadingLocation, data: locationData } = useQuery(GET_LOCATIONS, {
    variables: { id: currentOrgId },
  });

  // Query for the location groups
  const { loading: loadingAudiences, data: attributionAudiences } = useQuery(
    ATTRIBUTION_AUDIENCES_ORG_CONFIG,
    {
      variables: { TYPE: 'ATTRIBUTION', ORGID: currentOrgId },
    }
  );

  const [createAdvertiser] = useMutation(CREATE_ADVERTISERS);

  if (adminLoading || !data || loading || loadingLocation || loadingAudiences)
    return <OverlaySpinner />;

  const { mediajelAdminId, mediajelId } = adminIds.getAdminIds || {};
  // const total = data.full.aggregate.count;
  return (
    <AdvertiserMainController
      {...props}
      currentOrgId={currentOrgId}
      data={data.advertisersConnection.edges.map(({ node }) => node)}
      refetch={refetch}
      createAdvertiser={createAdvertiser}
      mediajelAdminId={mediajelAdminId}
      mediajelId={mediajelId}
      pageSize={pageSize}
      current={Number(pageNumber)}
      locationData={locationData}
      attributionAudiences={attributionAudiences}
      permission={permission}
      orgLevel={orgLevel}
      // total={total}
    >
      {children}
    </AdvertiserMainController>
  );
};

export default compose(
  graphql(CURRENT_USER, {
    props: ({ data: { currentUser }, ownProps }) => {
      return ownProps.currentUser || { currentUser };
    },
  })
)(withRouter(AdvertiserMainLoader));
